// Modal "Generar guía" de Nexus — copia fiel del de Conversaciones.js (no editar allá).
// Recibe el pedido de la vista Pedidos y arma el mismo contexto (shopifyOrders/shopifyContact).
import React, { useState, useEffect, useRef } from 'react';

const API = 'https://talku.online';
const authH = (extra = {}) => ({ 'Authorization': `Bearer ${localStorage.getItem('talku_token') || ''}`, ...extra });
const DEPTO_POR_CIUDAD = {
  'bogotá':'Cundinamarca','bogota':'Cundinamarca','medellín':'Antioquia','medellin':'Antioquia',
  'cali':'Valle del Cauca','barranquilla':'Atlántico','cúcuta':'Norte de Santander','cucuta':'Norte de Santander',
  'bucaramanga':'Santander','pereira':'Risaralda','santa marta':'Magdalena','cartagena':'Bolívar',
  'ibagué':'Tolima','ibague':'Tolima','pasto':'Nariño','manizales':'Caldas','neiva':'Huila',
  'villavicencio':'Meta','armenia':'Quindío','valledupar':'Cesar','montería':'Córdoba','monteria':'Córdoba',
  'sincelejo':'Sucre','popayán':'Cauca','popayan':'Cauca','tunja':'Boyacá','florencia':'Caquetá',
  'riohacha':'La Guajira','quibdó':'Chocó','quibdo':'Chocó','mocoa':'Putumayo','yopal':'Casanare',
  'arauca':'Arauca','leticia':'Amazonas','soacha':'Cundinamarca','palmira':'Valle del Cauca',
  'bello':'Antioquia','envigado':'Antioquia','itagüí':'Antioquia','itagui':'Antioquia',
  'floridablanca':'Santander','girón':'Santander','giron':'Santander','dosquebradas':'Risaralda',
  'cartago':'Valle del Cauca','buenaventura':'Valle del Cauca','barrancabermeja':'Santander',
  'duitama':'Boyacá','sogamoso':'Boyacá','ocaña':'Norte de Santander','pamplona':'Norte de Santander',
  'maicao':'La Guajira','uribia':'La Guajira','manaure':'La Guajira','fonseca':'La Guajira',
  'san juan del cesar':'La Guajira','villanueva':'La Guajira','albania':'La Guajira',
  'soledad':'Atlántico','sabanalarga':'Atlántico','malambo':'Atlántico',
  'zipaquirá':'Cundinamarca','zipaquira':'Cundinamarca','fusagasugá':'Cundinamarca',
  'fusagasuga':'Cundinamarca','facatativá':'Cundinamarca','facatativa':'Cundinamarca',
  'chía':'Cundinamarca','chia':'Cundinamarca','cajicá':'Cundinamarca','cajica':'Cundinamarca',
  'madrid':'Cundinamarca','funza':'Cundinamarca','mosquera':'Cundinamarca','girardot':'Cundinamarca',
  'sabaneta':'Antioquia','rionegro':'Antioquia','apartadó':'Antioquia','turbo':'Antioquia',
  'tulua':'Valle del Cauca','tuluá':'Valle del Cauca','buga':'Valle del Cauca',
  'piedecuesta':'Santander','lorica':'Córdoba','cereté':'Córdoba','sahagún':'Córdoba',
  'la virginia':'Risaralda','chiquinquirá':'Boyacá',
};
const inferDepto = (city) => city ? (DEPTO_POR_CIUDAD[(city||'').toLowerCase().trim()] || '') : '';
const CARRIERS_MAP = {
  coordinadora:    { label:'Coordinadora',     color:'#e30613', img:'/coordinadora-logo.webp' },
  servientrega:    { label:'Servientrega',     color:'#00529b', img:'/servientrega-logo.jpg' },
  interrapidisimo: { label:'Inter Rapidísimo', color:'#00a651', img:'/interrapidisimo-logo.jpg' },
  tcc:             { label:'TCC',              color:'#e4002b', img:'/tcc-logo.jpg' },
  envia:           { label:'Envía',            color:'#ff6600', img:'/envia-logo.jpg' },
};

export default function NexusGuideModal({ order, onClose, onDone }) {
  const o = order || {};
  const shopifyOrders = [{
    order_number: String(o.id || '').replace('#',''), product: o.producto, variant: o.variante, total: o.valor,
    metodo: o.metodo, items_detalle: o.items_detalle, financial_status: o.estado_pago,
    fulfillment_status: o.estado_envio === 'fulfilled' ? 'fulfilled' : null,
  }];
  const shopifyContact = { nombre: o.cliente, telefono: (o.telefono||'').replace(/\D/g,''), ciudad: o.ciudad && o.ciudad !== '—' ? o.ciudad : '', provincia: o.provincia, direccion: o.direccion, email: o.email };
  const [nxConfirm, setNxConfirm] = useState(false);
  const [nxShowData, setNxShowData] = useState(false); // eslint-disable-line no-unused-vars
  const [nexusOrderInfo, setNexusOrderInfo] = useState(null);
  const [nexusForm, setNexusForm] = useState({});
  const [nexusLoading, setNexusLoading] = useState(false);
  const [nexusMsg, setNexusMsg] = useState('');
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [cityQuery, setCityQuery] = useState('');
  const [citySearching, setCitySearching] = useState(false);
  const cityTimeoutRef = useRef(null);
  const [shippingQuotes, setShippingQuotes] = useState([]);
  const [quotesLoading, setQuotesLoading] = useState(false);
  const [selectedCarrier, setSelectedCarrier] = useState('coordinadora');
  const [nexusProductImg, setNexusProductImg] = useState(null);
  const [nexusProductTitle, setNexusProductTitle] = useState('');

  const openNexusModal = async (shopifyOrderId) => {
    setNexusMsg(''); setNexusLoading(true); setNxConfirm(false); setNxShowData(false);
    try {
      const res = await fetch(`${API}/nexus/by-shopify-order/${shopifyOrderId}`, { headers: authH() });
      const d = await res.json();
      setNexusOrderInfo({ ...d, shopify_order_id: shopifyOrderId });

      // Intentar cargar datos reales desde Nexus para pre-llenar el form
      let nexusDetail = null;
      if (d.has_nexus) {
        try {
          const dr = await fetch(`${API}/nexus/orders/${shopifyOrderId}/detail`, { headers: authH() });
          if (dr.ok) nexusDetail = await dr.json();
        } catch(_) {}
      }

      const conv = null;
      const phone = shopifyContact?.telefono || (conv?.contact_phone || '').replace(/\D/g, '');
      const ord = shopifyOrders.find(o => o.fulfillment_status !== 'fulfilled') || shopifyOrders[0];
      const _city = nexusDetail?.city || nexusDetail?.ciudad || shopifyContact?.ciudad || '';
      const _state = nexusDetail?.state || nexusDetail?.department || nexusDetail?.departamento || shopifyContact?.provincia || inferDepto(_city);
      setNexusForm({
        customer_name:       nexusDetail?.customer_name || shopifyContact?.nombre || conv?.contact_name || '',
        customer_phone:      nexusDetail?.customer_phone || phone || '',
        shipping_address:    nexusDetail?.shipping_address || nexusDetail?.address || shopifyContact?.direccion || '',
        city:                _city,
        city_code:           '',
        state:               _state,
        content_description: nexusDetail?.content_description || ord?.variant || '',
        total_amount:        nexusDetail?.total_amount || nexusDetail?.total || String(ord?.total || '') || '',
        customer_email:      nexusDetail?.customer_email || nexusDetail?.email || shopifyContact?.email || '',
      });
      setCityQuery(_city ? `${_city}${_state ? ', ' + _state : ''}` : '');
      setCitySuggestions([]);
      const pName = nexusDetail?.product_name || ord?.product || '';
      const vName = nexusDetail?.variant_selected || ord?.variant || '';
      setNexusProductTitle(vName && pName.endsWith(vName) ? pName.slice(0, -vName.length).replace(/\s*-\s*$/, '').trim() : pName);
      const nexusImg = nexusDetail?.variant_image_url || nexusDetail?.product_image || null;
      setNexusProductImg(nexusImg);
      if (!nexusImg) {
        const variantId = ord?.items_detalle?.[0]?.variant_id;
        if (variantId) {
          try {
            const imgRes = await fetch(`${API}/orders/variant-image/${variantId}`, { headers: authH() });
            if (imgRes.ok) { const imgD = await imgRes.json(); if (imgD.image_url) setNexusProductImg(imgD.image_url); }
          } catch(_) {}
        }
      }
      setShippingQuotes([]); setSelectedCarrier('coordinadora');
      if (d.has_nexus) {
        try {
          const qr = await fetch(`${API}/nexus/orders/${shopifyOrderId}/quote`, { method: 'POST', headers: authH() });
          if (qr.ok) { const qd = await qr.json(); setShippingQuotes(qd.quotes || qd.data || []); }
        } catch(_) {}
      }
    } catch(e) {
      setNexusMsg(`Error: ${e?.message || String(e)}`);
    } finally { setNexusLoading(false); }
  };

  const nexusGenerateGuide = async () => {
    if (!nexusOrderInfo?.shopify_order_id) return;
    setNexusLoading(true); setNexusMsg('');
    try {
      // 1. Actualizar datos en Nexus antes de generar
      const updateFields = Object.fromEntries(Object.entries(nexusForm).filter(([,v]) => String(v).trim() !== '' && v !== null && v !== undefined));
      // content_description con TODOS los productos de todos los pedidos a despachar
      const _gOrders = (() => {
        const p = shopifyOrders.filter(o => o.fulfillment_status !== 'fulfilled');
        return p.length ? p : (shopifyOrders.length ? [shopifyOrders[0]] : []);
      })();
      const _validName = (s) => { const t = (s == null ? '' : String(s)); const tt = t.trim(); return (tt !== '' && tt !== '—' && tt !== '–') ? t : ''; };
      const _fullDesc = _gOrders
        .flatMap(o => (o.items_detalle && o.items_detalle.length > 0
          ? o.items_detalle
          : [{ producto: o.product, variante: o.variant, cantidad: 1 }]).map(it => ({ ...it, _oproduct: o.product })))
        .map(it => {
          const p = _validName(it.producto) || _validName(it.title) || _validName(it._oproduct) || 'Producto';
          const v = it.variante || it.variant_title || '';
          const q = it.cantidad || it.quantity || 1;
          return `${p}${v && v !== '—' ? ' - ' + v : ''}${q > 1 ? ' x' + q : ''}`;
        })
        .filter(Boolean).join(' + ');
      if (_fullDesc) updateFields.content_description = _fullDesc;
      if (Object.keys(updateFields).length > 0) {
        const patchRes = await fetch(`${API}/nexus/orders/${nexusOrderInfo.shopify_order_id}`, {
          method: 'PATCH',
          headers: authH({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(updateFields),
        });
        if (!patchRes.ok) {
          const patchErr = await patchRes.json().catch(() => ({}));
          setNexusMsg('❌ Error al actualizar datos en Nexus: ' + (patchErr.detail || patchRes.status) + '. Corrija los datos e intente de nuevo.');
          setNexusLoading(false);
          return;
        }
      }
      // 2. Generar guía
      const res = await fetch(`${API}/nexus/orders/${nexusOrderInfo.shopify_order_id}/generate-guide`, { method: 'POST', headers: authH({ 'Content-Type': 'application/json' }), body: JSON.stringify({ carrier: selectedCarrier }) });
      const d = await res.json();
      if (d.guide_number) {
        // El backend devuelve 200 con already_existed=true cuando Nexus responde 409
        // (guía ya activa). No es una guía nueva: se sincroniza la existente.
        const label = d.already_existed ? '✅ Guía sincronizada (ya existía)' : '✅ Guía generada';
        setNexusMsg(`${label}: ${d.guide_number}`);
        setNexusOrderInfo(prev => ({ ...prev, tracking_number: d.guide_number, carrier_status: 'shipped' }));
        const conv = null;
        onDone && onDone();
      } else {
        setNexusMsg(`❌ ${d.message || d.detail || 'Error generando guía'}`);
      }
    } catch(e) {
      setNexusMsg('❌ Error de conexión');
    } finally { setNexusLoading(false); }
  };

  useEffect(() => { if (o.shopify_id) openNexusModal(o.shopify_id); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <style>{`
        .nxm-root .modal-overlay{position:fixed;inset:0;z-index:600;display:flex;align-items:center;justify-content:center;}
        .nxm-root .spinner{width:18px;height:18px;border:2px solid #e8e8e6;border-top-color:#0a0a0a;border-radius:50%;animation:nxm-spin 0.7s linear infinite;display:inline-block;}
        @keyframes nxm-spin{to{transform:rotate(360deg)}}
      `}</style>
      <div className="nxm-root">
        <div className="modal-overlay" onClick={e=>e.stopPropagation()} style={{background:'rgba(15,15,20,0.45)'}}>
          <style>{`
            @keyframes nx2Up { from { opacity:0; transform:translateY(12px) scale(.985); } to { opacity:1; transform:none; } }
            @keyframes nx2In { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:none; } }
            .nx2 { zoom:1.1; width:min(1240px,88vw); max-height:84vh; background:#fff; border:1px solid #e5e5e5; border-radius:10px; box-shadow:0 20px 56px rgba(0,0,0,.18); display:flex; flex-direction:column; overflow:hidden; animation:nx2Up .3s cubic-bezier(.22,1,.36,1) both; }
            .nx2-head { display:flex; align-items:center; justify-content:space-between; padding:16px 22px; border-bottom:1px solid #eee; }
            .nx2-logo { width:34px; height:34px; border-radius:8px; background:#fff0f6; border:1px solid #fbd0e3; display:flex; align-items:center; justify-content:center; }
            .nx2-x { width:30px; height:30px; border-radius:6px; border:none; background:transparent; color:#777; display:flex; align-items:center; justify-content:center; cursor:pointer; transition:background .15s; }
            .nx2-x:hover { background:#f2f2f2; color:#111; }
            .nx2-body { overflow:auto; flex:1; padding:18px 22px 22px; }
            .nx2-sec { animation:nx2In .3s ease both; margin-top:18px; }
            .nx2-st { font-size:13px; font-weight:600; color:#111; margin-bottom:10px; display:flex; align-items:center; gap:8px; }
            .nx2-st small { font-size:12px; font-weight:400; color:#888; }
            .nx2-sum { border:1px solid #e5e5e5; border-radius:8px; padding:14px 16px; display:flex; justify-content:space-between; gap:12px; flex-wrap:wrap; animation:nx2In .3s ease both; }
            .nx2-ped { font-size:11.5px; color:#f90370; font-weight:500; }
            .nx2-cli { font-size:15px; font-weight:600; color:#111; margin-top:2px; }
            .nx2-city { font-size:12.5px; color:#666; margin-top:2px; }
            .nx2-total { font-size:26px; font-weight:600; color:#111; letter-spacing:-.02em; text-align:right; line-height:1; }
            .nx2-tl { font-size:11.5px; color:#888; text-align:right; margin-top:4px; }
            .nx2-pay { display:inline-block; margin-top:6px; font-size:11px; border-radius:4px; padding:2px 8px; }
            .nx2-guide { margin-top:12px; padding-top:12px; border-top:1px solid #f0f0f0; display:flex; align-items:center; justify-content:space-between; gap:12px; width:100%; }
            .nx2-pdf { height:30px; padding:0 12px; border-radius:6px; border:1px solid #dcdcdc; background:#fff; color:#111; font-size:12.5px; font-weight:400; cursor:pointer; font-family:inherit; display:flex; align-items:center; gap:6px; }
            .nx2-pdf:hover { background:#f5f5f5; }
            .nx2-items { border:1px solid #e5e5e5; border-radius:8px; overflow:hidden; }
            .nx2-item { display:flex; align-items:center; gap:12px; padding:9px 12px; border-bottom:1px solid #f1f1f1; }
            .nx2-item:last-child { border-bottom:none; }
            .nx2-img { width:40px; height:40px; border-radius:6px; object-fit:cover; background:#f0f0f0; flex-shrink:0; border:1px solid #eee; }
            .nx2-carriers { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
            .nx2-car { position:relative; text-align:left; border:1px solid #e3e3e3; border-radius:8px; background:#fff; padding:12px; cursor:pointer; font-family:inherit; transition:border-color .15s, box-shadow .15s; }
            .nx2-car:hover:not(:disabled) { border-color:#bdbdbd; }
            .nx2-car.on { border-color:#f90370; box-shadow:0 0 0 1px #f90370; background:#fff8fb; }
            .nx2-car:disabled { opacity:.45; cursor:not-allowed; }
            .nx2-car-top { display:flex; align-items:center; gap:10px; }
            .nx2-car-logo { width:34px; height:34px; border-radius:6px; border:1px solid #eee; background:#fff; display:flex; align-items:center; justify-content:center; overflow:hidden; flex-shrink:0; }
            .nx2-car-n { font-size:13px; font-weight:500; color:#111; flex:1; }
            .nx2-best { font-size:10.5px; color:#0f766e; background:#ecfdf5; border:1px solid #c7eedc; border-radius:4px; padding:1px 6px; }
            .nx2-car-g { display:grid; grid-template-columns:repeat(3,1fr); gap:6px; margin-top:10px; }
            .nx2-car-g span { display:block; font-size:10.5px; color:#888; }
            .nx2-car-g b { font-size:13px; font-weight:500; color:#111; }
            .nx2-car-g .dep { color:#15803d; }
            .nx2-check { position:absolute; top:10px; right:10px; width:18px; height:18px; border-radius:50%; background:#f90370; display:flex; align-items:center; justify-content:center; }
            .nx2-toggle { width:100%; display:flex; align-items:center; justify-content:space-between; border:1px solid #e5e5e5; border-radius:8px; background:#fafafa; padding:11px 14px; cursor:pointer; font-family:inherit; font-size:13px; color:#111; }
            .nx2-toggle:hover { background:#f4f4f4; }
            .nx2-toggle .warn { font-size:11.5px; color:#b45309; margin-left:8px; }
            .nx2-form { display:grid; grid-template-columns:1fr 1fr; gap:10px; animation:nx2In .25s ease both; }
            .nx2-cols { display:grid; grid-template-columns:1fr 1.15fr 1fr; gap:0; align-items:stretch; margin:-18px -22px -22px; }
            .nx2-c { padding:18px 22px 22px; min-width:0; }
            .nx2-c + .nx2-c { border-left:1px solid #eee; }
            .nx2-first { margin-top:0 !important; }
            .nx2-warn { font-size:11px; font-weight:400; color:#b45309; background:#fff8eb; border:1px solid #f5dcaa; border-radius:4px; padding:1px 6px; }
            @media (max-width:1100px) { .nx2-cols { grid-template-columns:1fr 1fr; } .nx2-c:nth-child(3) { grid-column:1 / -1; border-left:none; border-top:1px solid #eee; } }
            @media (max-width:760px) { .nx2-cols { grid-template-columns:1fr; } .nx2-c + .nx2-c { border-left:none; border-top:1px solid #eee; } }
            .nx2-form .full { grid-column:1 / -1; }
            .nx-input { width:100%; padding:9px 11px; border:1px solid #dcdcdc; border-radius:6px; font-size:13px; font-family:inherit; outline:none; box-sizing:border-box; background:#fff; color:#111; transition:border-color .15s, box-shadow .15s; }
            .nx-input:focus { border-color:#f90370; box-shadow:0 0 0 2px rgba(249,3,112,.12); }
            .nx-label { font-size:11.5px; font-weight:500; color:#f90370; display:block; margin-bottom:5px; }
            .nx2-foot { border-top:1px solid #eee; padding:12px 22px 14px; display:flex; align-items:center; gap:14px; background:#fff; }
            .nx2-fs { flex:1; font-size:12px; color:#666; line-height:1.5; }
            .nx2-fs b { color:#111; font-weight:500; }
            .nx2-btn { height:38px; padding:0 16px; border-radius:6px; font-family:inherit; font-size:13.5px; font-weight:400; cursor:pointer; display:flex; align-items:center; gap:8px; transition:background .15s; }
            .nx2-btn.ghost { border:1px solid #dcdcdc; background:#fff; color:#111; } .nx2-btn.ghost:hover { background:#f5f5f5; }
            .nx2-btn.gen { border:none; background:#f90370; color:#fff; } .nx2-btn.gen:hover { background:#e00265; } .nx2-btn.gen:disabled { background:#d0d0d0; cursor:not-allowed; }
            .nx2-confirm { background:#fff8fb; border-top:1px solid #fbd0e3; }
            @media (max-width:640px) { .nx2-carriers, .nx2-form { grid-template-columns:1fr; } .nx2-foot { flex-wrap:wrap; } }
          `}</style>
          <div className="nx2" onClick={e=>e.stopPropagation()}>
            <div className="nx2-head">
              <div style={{display:'flex',alignItems:'center',gap:12}}>
                <div className="nx2-logo"><img src="/nexus-logo.png" alt="Nexus" style={{width:20,height:20,objectFit:'contain'}}/></div>
                <div>
                  <div style={{fontSize:16,fontWeight:600,color:'#111'}}>Generar guía</div>
                  <div style={{fontSize:12,color:'#888',marginTop:1}}>
                    {nexusOrderInfo?.tracking_number ? `Guía actual: ${nexusOrderInfo.tracking_number}` : nexusOrderInfo?.has_nexus ? 'Nexus · Sin guía generada' : 'Pedido no vinculado a Nexus'}
                  </div>
                </div>
              </div>
              <button className="nx2-x" onClick={()=>{ onClose(); setNexusMsg(''); setNxConfirm(false); }} aria-label="Cerrar"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
            </div>

            <div className="nx2-body">
            {nexusMsg && (
              <div style={{margin:'0 0 12px',background:nexusMsg.includes('✅')?'#f0fdf4':nexusMsg.includes('⚠️')?'#fffbeb':'#fef2f2',border:`1px solid ${nexusMsg.includes('✅')?'#bbf7d0':nexusMsg.includes('⚠️')?'#fde68a':'#fee2e2'}`,borderRadius:8,padding:'11px 14px',fontSize:13,color:nexusMsg.includes('✅')?'#16a34a':nexusMsg.includes('⚠️')?'#92400e':'#ef4444',flexShrink:0,animation:'nxFadeCol .3s ease both'}}>{nexusMsg}</div>
            )}

            {nexusLoading && !nexusMsg && (
              <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'56px 0',flex:1,gap:12}}>
                <div className="spinner" style={{width:24,height:24,borderWidth:3}}/>
                <span style={{fontSize:13,color:'#aaa'}}>Cargando datos del pedido...</span>
              </div>
            )}

            {nexusLoading && !nexusMsg && (
              <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'48px 0',gap:12}}>
                <div className="spinner" style={{width:22,height:22}}/>
                <span style={{fontSize:13,color:'#999'}}>Cargando datos del pedido…</span>
              </div>
            )}

            {!nexusOrderInfo?.has_nexus && !nexusLoading && (
              <div style={{margin:'0',background:'#fffbeb',border:'1px solid #fde68a',borderRadius:8,padding:'14px 16px',fontSize:13,color:'#92400e',display:'flex',alignItems:'center',gap:10,animation:'nxFadeCol .3s ease both'}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                Este pedido aún no está vinculado a Nexus. Espera a que llegue el webhook de <strong>nueva_orden</strong>.
              </div>
            )}

            {nexusOrderInfo?.has_nexus && !nexusLoading && (() => {
              const ord = shopifyOrders.find(o=>o.fulfillment_status!=='fulfilled') || shopifyOrders[0];
              const isPaid = ord?.financial_status === 'paid' || (ord?.metodo && ord.metodo !== 'COD' && ord.metodo !== 'cash_on_delivery' && ord.metodo !== '—');
              const imgSrc = nexusProductImg || null;
              const productName = nexusProductTitle || ord?.product || 'Producto';
              // Todos los productos de TODOS los pedidos a despachar (no cumplidos).
              const _guideOrders = (() => {
                const pend = shopifyOrders.filter(o => o.fulfillment_status !== 'fulfilled');
                return pend.length ? pend : (shopifyOrders.length ? [shopifyOrders[0]] : []);
              })();
              const _guideName = (s) => { const t = (s == null ? '' : String(s)); const tt = t.trim(); return (tt !== '' && tt !== '—' && tt !== '–') ? t : ''; };
              const guideItems = _guideOrders.flatMap(o =>
                (o.items_detalle && o.items_detalle.length > 0
                  ? o.items_detalle
                  : [{ producto: o.product, variante: o.variant, cantidad: 1 }]
                ).map(it => ({
                  producto: _guideName(it.producto) || _guideName(it.title) || _guideName(o.product) || 'Producto',
                  variante: it.variante || it.variant_title || o.variant || '',
                  cantidad: it.cantidad || it.quantity || 1,
                }))
              );
              const nf = (key) => nexusForm[key] || '';
              const setNf = (key,val) => setNexusForm(p=>({...p,[key]:val}));
              const CARRIERS = ['coordinadora','servientrega','interrapidisimo','tcc'].map(id=>({id,...CARRIERS_MAP[id]}));
              const sel = shippingQuotes.find(q => q.carrier === selectedCarrier);
              const quotesFor = (id) => shippingQuotes.find(q => q.carrier === id);
              const cheapest = shippingQuotes.length ? shippingQuotes.reduce((m, q) => (Number(q.total||0) < Number(m.total||0) ? q : m)).carrier : null;
              const money = (v) => `$${Number(v||0).toLocaleString('es-CO')}`;
              const missing = !nexusForm.city_code || !String(nf('shipping_address')).trim() || !String(nf('customer_name')).trim();
              return (
                <div className="nx2-cols">
                  <div className="nx2-c">
                  {/* 1 · Resumen */}
                  <div className="nx2-sum">
                    <div style={{minWidth:0}}>
                      <div className="nx2-ped">Pedido #{ord?.order_number || nexusOrderInfo?.shopify_order_id || '—'}</div>
                      <div className="nx2-cli">{nf('customer_name') || '—'}</div>
                      <div className="nx2-city">{(nf('city') || cityQuery || 'Ciudad sin definir')}{nf('state') ? `, ${nf('state')}` : ''} · {nf('customer_phone') || 'sin teléfono'}</div>
                    </div>
                    <div>
                      <div className="nx2-total">{money(nexusForm.total_amount||ord?.total)}</div>
                      <div className="nx2-tl">Total a recaudar</div>
                      <div style={{textAlign:'right'}}><span className="nx2-pay" style={{background:isPaid?'#effaf4':'#fff8eb',color:isPaid?'#15803d':'#b45309',border:`1px solid ${isPaid?'#c9ead8':'#f5dcaa'}`}}>{`${ord?.metodo && ord.metodo!=='—' ? ord.metodo+' · ' : ''}${isPaid?'Pagado':'Pendiente de pago'}`}</span></div>
                    </div>
                    {nexusOrderInfo?.tracking_number && (
                      <div className="nx2-guide">
                        <div style={{fontSize:12.5,color:'#555'}}>
                          Guía actual <a href={`https://www.coordinadora.com/portafolio-de-servicios/servicios-en-linea/rastrear-guias/?guia=${nexusOrderInfo.tracking_number}`} target="_blank" rel="noreferrer" style={{color:'#f90370',textDecoration:'none',fontWeight:500,marginLeft:4}}>{nexusOrderInfo.tracking_number}</a>
                          {(nexusOrderInfo?.carrier || nexusOrderInfo?.carrier_status) && <span style={{color:'#888'}}> · {CARRIERS_MAP[nexusOrderInfo?.carrier]?.label || nexusOrderInfo?.carrier || ''}{nexusOrderInfo?.carrier_status ? ` · ${nexusOrderInfo.carrier_status}` : ''}</span>}
                        </div>
                        <button onClick={async()=>{
                          try {
                            const r = await fetch(`${API}/nexus/orders/${nexusOrderInfo.shopify_order_id}/label`,{headers:authH()});
                            const d = await r.json();
                            if (d.pdf_b64) { const w=window.open(''); w.document.write(`<iframe src="data:application/pdf;base64,${d.pdf_b64}" style="width:100%;height:100vh;border:none;"></iframe>`); }
                            else alert('PDF no disponible aún');
                          } catch { alert('Error al obtener el PDF'); }
                        }} className="nx2-pdf">
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
                          PDF
                        </button>
                      </div>
                    )}
                  </div>

                  {/* 2 · Productos */}
                  <div className="nx2-sec">
                    <div className="nx2-st">Productos <small>{guideItems.length} {guideItems.length===1?'producto':'productos'}</small></div>
                    <div className="nx2-items">
                      {guideItems.map((it, idx) => (
                        <div key={idx} className="nx2-item">
                          {idx===0 && imgSrc ? <img src={imgSrc} alt="" className="nx2-img" onError={e=>e.target.style.display='none'}/> : <div className="nx2-img"/>}
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{fontSize:13,color:'#111'}}>{it.producto}</div>
                            {it.variante && it.variante !== '—' && <div style={{fontSize:11.5,color:'#888',marginTop:1}}>{it.variante}</div>}
                          </div>
                          <div style={{fontSize:12,color:'#666'}}>x{it.cantidad}</div>
                        </div>
                      ))}
                    </div>
                    <div style={{marginTop:10}}>
                      <label className="nx-label">Variante / contenido de la guía</label>
                      <input className="nx-input" value={nf('content_description')} onChange={e=>setNf('content_description',e.target.value)} placeholder="Ej: MARRON / 43"/>
                    </div>
                  </div>

                  </div>
                  <div className="nx2-c">
                  {/* 4 · Datos de envío */}
                  <div className="nx2-sec nx2-first">
                    <div className="nx2-st">Datos de envío{missing && <span className="nx2-warn">Faltan datos</span>}</div>
                    {(
                      <div className="nx2-form">
                        <div><label className="nx-label">Nombre completo</label><input className="nx-input" value={nf('customer_name')} onChange={e=>setNf('customer_name',e.target.value)}/></div>
                        <div><label className="nx-label">Teléfono</label><input className="nx-input" value={nf('customer_phone')} onChange={e=>setNf('customer_phone',e.target.value)}/></div>
                        <div style={{position:'relative'}}>
                          <label className="nx-label">Ciudad</label>
                          <input className="nx-input"
                            value={cityQuery}
                            onChange={e => {
                              const v = e.target.value;
                              setCityQuery(v);
                              setNf('city',''); setNf('city_code',''); setNf('state','');
                              if (cityTimeoutRef.current) clearTimeout(cityTimeoutRef.current);
                              if (v.length >= 2) {
                                setCitySearching(true);
                                cityTimeoutRef.current = setTimeout(async () => {
                                  try {
                                    const r = await fetch(`${API}/nexus/cities?q=${encodeURIComponent(v)}`, { headers: authH() });
                                    if (r.ok) { const d = await r.json(); setCitySuggestions(Array.isArray(d) ? d : []); }
                                  } catch(_) {}
                                  setCitySearching(false);
                                }, 350);
                              } else { setCitySuggestions([]); setCitySearching(false); }
                            }}
                            placeholder="Escribe para buscar ciudad..."
                            style={{borderColor: nexusForm.city_code ? '#6ee7b7' : undefined, background: nexusForm.city_code ? '#f0fdf4' : undefined}}
                            onFocus={e=>{ if (!nexusForm.city_code) e.target.style.borderColor='#6ee7b7'; }}
                            onBlur={e=>{ setTimeout(()=>setCitySuggestions([]),200); if (!nexusForm.city_code) e.target.style.borderColor=''; }}
                          />
                          {nexusForm.city_code && <div style={{fontSize:10,color:'#16a34a',marginTop:3,fontWeight:600}}>DANE: {nexusForm.city_code}</div>}
                          {citySearching && <div style={{fontSize:11,color:'#999',marginTop:3}}>Buscando...</div>}
                          {citySuggestions.length > 0 && (
                            <div style={{position:'absolute',top:'100%',left:0,right:0,background:'#fff',border:'1.5px solid #e8e8e6',borderRadius:10,marginTop:4,maxHeight:180,overflowY:'auto',zIndex:100,boxShadow:'0 8px 24px rgba(0,0,0,0.1)'}}>
                              {citySuggestions.map((c, i) => (
                                <div key={i}
                                  onMouseDown={e => {
                                    e.preventDefault();
                                    const nombre = c.nombre || c.city || '';
                                    const depto = c.departamento || c.department || '';
                                    const code = c.codigo_dane || c.city_code || '';
                                    setNf('city', nombre); setNf('state', depto); setNf('city_code', code);
                                    setCityQuery(`${nombre}, ${depto}`);
                                    setCitySuggestions([]);
                                    if (code) {
                                      const total = parseInt(nexusForm.total_amount) || 0;
                                      if (total > 0) {
                                        setQuotesLoading(true); setShippingQuotes([]);
                                        fetch(`${API}/nexus/quote-by-city`, { method:'POST', headers:authH({'Content-Type':'application/json'}), body:JSON.stringify({city_code:code,total}) })
                                          .then(r=>r.ok?r.json():null).then(d=>{ if(d?.quotes) setShippingQuotes(d.quotes); }).catch(()=>{}).finally(()=>setQuotesLoading(false));
                                      }
                                    }
                                  }}
                                  style={{padding:'9px 14px',fontSize:12,cursor:'pointer',borderBottom:i<citySuggestions.length-1?'1px solid #f0f0ee':'none',transition:'background 0.15s'}}
                                  onMouseEnter={e=>e.target.style.background='#f8f8f6'}
                                  onMouseLeave={e=>e.target.style.background='#fff'}
                                >
                                  <span style={{fontWeight:600,color:'#0a0a0a'}}>{c.nombre || c.city}</span>
                                  <span style={{color:'#999',marginLeft:6,fontSize:11}}>{c.departamento || c.department}</span>
                                  <span style={{color:'#bbb',marginLeft:4,fontSize:10}}>({c.codigo_dane || c.city_code})</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div>
                          <label className="nx-label">Departamento</label>
                          <input className="nx-input" value={nf('state')} readOnly placeholder="Se llena al elegir la ciudad" style={{background:'#f6f6f6',color:'#666'}}/>
                        </div>
                        <div className="full"><label className="nx-label">Dirección y complementos</label><input className="nx-input" value={nf('shipping_address')} onChange={e=>setNf('shipping_address',e.target.value)}/></div>
                        <div><label className="nx-label">Correo electrónico</label><input className="nx-input" value={nf('customer_email')} onChange={e=>setNf('customer_email',e.target.value)} placeholder="opcional@email.com"/></div>
                        <div><label className="nx-label">Total a recaudar (COD)</label><input className="nx-input" value={nf('total_amount')} onChange={e=>setNf('total_amount',e.target.value.replace(/\D/g,''))}/></div>
                      </div>
                    )}
                  </div>
                  </div>
                  <div className="nx2-c">
                  {/* 3 · Transportadora */}
                  <div className="nx2-sec nx2-first">
                    <div className="nx2-st">Transportadora {quotesLoading && <small style={{display:'flex',alignItems:'center',gap:6}}><span className="spinner" style={{width:11,height:11}}/> Cotizando…</small>}</div>
                    <div className="nx2-carriers">
                      {CARRIERS.map(c => {
                        const q = quotesFor(c.id); const active = selectedCarrier === c.id;
                        return (
                          <button key={c.id} className={`nx2-car${active?' on':''}`} disabled={!q} onClick={()=> q && setSelectedCarrier(c.id)}>
                            <div className="nx2-car-top">
                              <div className="nx2-car-logo">{c.img ? <img src={c.img} alt="" style={{width:28,height:28,objectFit:'contain'}}/> : <span style={{fontSize:10,color:c.color}}>{c.label?.slice(0,3)}</span>}</div>
                              <span className="nx2-car-n">{c.label}</span>
                              {q && cheapest === c.id && !active && <span className="nx2-best">Más económica</span>}
                            </div>
                            {q ? (
                              <div className="nx2-car-g">
                                <div><span>Flete</span><b>{money(q.total)}</b></div>
                                <div><span>Tiempo</span><b>{q.delivery_time} día{String(q.delivery_time)!=='1'?'s':''}</b></div>
                                <div><span>Se deposita</span><b className="dep">{money(q.value_deposited)}</b></div>
                              </div>
                            ) : <div style={{fontSize:11.5,color:'#aaa',marginTop:10}}>{quotesLoading ? 'Cotizando…' : 'Sin cotización'}</div>}
                            {active && <span className="nx2-check"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>}
                          </button>
                        );
                      })}
                    </div>
                    {!quotesLoading && shippingQuotes.length === 0 && <div style={{fontSize:12,color:'#999',marginTop:8}}>No hay cotización todavía. Revisa la ciudad en los datos de envío.</div>}
                  </div>

                  </div>
                </div>
              );
            })()}
            </div>

            {nexusOrderInfo?.has_nexus && !nexusLoading && (() => {
              const sel = shippingQuotes.find(q => q.carrier === selectedCarrier);
              const money = (v) => `$${Number(v||0).toLocaleString('es-CO')}`;
              const carrierName = CARRIERS_MAP[selectedCarrier]?.label || selectedCarrier || 'la transportadora';
              return nxConfirm ? (
                <div className="nx2-foot nx2-confirm">
                  <div className="nx2-fs">¿Generar la guía con <b>{carrierName}</b>{sel ? <> por <b>{money(sel.total)}</b></> : null}? Esto crea un <b>envío real</b> en Nexus.</div>
                  <button className="nx2-btn ghost" onClick={()=>setNxConfirm(false)}>Volver</button>
                  <button className="nx2-btn gen" disabled={nexusLoading} onClick={()=>{ setNxConfirm(false); nexusGenerateGuide(); }}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 3v5a2 2 0 0 1-2 2h-1"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Sí, generar guía</button>
                </div>
              ) : (
                <div className="nx2-foot">
                  <div className="nx2-fs">{sel ? <>{carrierName} · Envío <b>{money(sel.total)}</b> · Se deposita <b style={{color:'#15803d'}}>{money(sel.value_deposited)}</b></> : 'Elige una transportadora'}</div>
                  <button className="nx2-btn ghost" onClick={()=>{ onClose(); setNexusMsg(''); }}>Cancelar</button>
                  <button className="nx2-btn gen" disabled={nexusLoading} onClick={()=>setNxConfirm(true)}>
                    {nexusLoading ? <><div className="spinner" style={{width:13,height:13,borderTopColor:'#fff',borderColor:'rgba(255,255,255,0.3)'}}/> Generando…</> : <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 3v5a2 2 0 0 1-2 2h-1"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Generar guía</>}
                  </button>
                </div>
              );
            })()}
          </div>
        </div>
      </div>
    </>
  );
}
